var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"l-section l-section--tall"},[_c('ThumbList',{attrs:{"title":_vm.page.content.header_title,"titleClass":"t-t1-serif","categories":_vm.categories}})],1),_c('Instagram')],1)}
var staticRenderFns = []

export { render, staticRenderFns }